// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".browser[data-v-a5aa3cf4] {\n  flex-flow: column;\n}\n.buttons[data-v-a5aa3cf4] {\n  background: #fff;\n  padding: 0.25em;\n}\n.buttons .px-btn[data-v-a5aa3cf4] {\n  flex: 1;\n  padding: 1.618em;\n}\n", ""]);
// Exports
module.exports = exports;
